var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses},[_c('icon-warning',{staticClass:"gc-alert-injury__icon",attrs:{"size":"sm1"}}),_c('text-content',{attrs:{"weight":'medium',"lineHeight":'multi',"size":'sm1'}},[_c('strong',[_vm._v(_vm._s(_vm.name)+" ")]),_c('a',{domProps:{"innerHTML":_vm._s(_vm.description)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }